export var getControlsMarginBottom = function (isVisualNavigation, mb) {
    return mb !== undefined
        ? mb
        : isVisualNavigation // @TODO: Remove isVisualNavigation and other hardcoded values by refactoring it
            ? [null, '-18px', '-2px']
            : ['32px', 0];
};
export var getControlsPositionX = function (isVisualNavigation, positionX) { return (isVisualNavigation ? positionX : 0); };
